import React, { Component } from 'react';
import AcceptedJobView from './AcceptedJobView';
import { url } from '../../../Server/url/GlobalUrl'
import moment from 'moment'

class AcceptedJobComponent extends Component {
    state={
        job_detail : [],
        modal_show: false,
        authResponse: '',
        card : true,
        list_active : '',
        card_active : 'active',
        expand:'none',
        qualification: [],
        expand_id: '',
        length : 0,
    }
    handledelete = (id) => {
        console.log('hello all deleted',id)
        const token = localStorage.getItem("token")
         fetch((url + "/jobs/user-applied-jobs/"  + id + '/'), {
                method: 'DELETE',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token,
                },
                })
                .then((response) => {
                     if (response['status'] === 201 || response['status'] === 200 || response['status'] === 204) {
        fetch((url + "/jobs/user-applied-jobs/?user=" + localStorage.getItem('cv-id')), {
                        method: 'GET',
                         headers: {
                           'Accept': 'application/json',
                           'Content-Type': 'application/json',
                           'Authorization': 'Bearer ' + token,
                        },
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                            console.log('result+',result)

                            if (result.length>0){
                             var i;
                                for (i of result) {
                                    var day = moment(result.date_applied).format("MMMM DD, YYYY")
                                    i['date_applied'] = day
                                    console.log('day',day)

                                }
                                console.log('check status',result)
                                 this.setState({
                                job_detail : result
                            })

                             }

                        })

                      } else if (response['status'] === 400) {
                            this.showCustomModal()
                            this.setState({authResponse:'Something went wrong please try again'})
                      }
                })
         }

    componentDidMount() {
        let auth = localStorage.getItem("token")
        fetch((url + "/jobs/accepted-jobs/"), {
                        method: 'GET',
                         headers: {
                           'Accept': 'application/json',
                           'Content-Type': 'application/json',
                           'Authorization': 'Bearer ' + auth,
                        },
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                            console.log('result++',result)

                            if (result.length>0){
                            this.setState({length : result.length})
                             var i;
                            for (i of result) {
                                if (i.job_start_date_arrival_time || i.job_start_date_departure_time || i.job_end_date_arrival_time || i.job_end_date_departure_time){
                                    if (i.job_start_date_arrival_time ){
                                        var start_date_arrival_time = this.tConvert(i.job_start_date_arrival_time)
                                        i['job_start_date_arrival_time'] = start_date_arrival_time
                                    }
                                    if(i.job_start_date_departure_time){
                                        var start_date_departure_time = this.tConvert(i.job_start_date_departure_time)
                                        i['job_start_date_departure_time'] = start_date_departure_time
                                    }
                                    if(i.job_end_date_arrival_time){
                                        var end_date_arrival_time = this.tConvert(i.job_end_date_arrival_time)
                                        i['job_end_date_arrival_time'] = end_date_arrival_time
                                    }
                                    if(i.job_end_date_departure_time){
                                        var end_date_departure_time = this.tConvert(i.job_end_date_departure_time)
                                        i['job_end_date_departure_time'] = end_date_departure_time
                                    }
                                }
                                if(i.job_start_date){
                                    var day = moment(i.job_start_date).format("dddd DD/MM")
                                    var formmated_day = moment(i.job_end_date).format("MMMM DD, YYYY")
                                    i['job_start_date'] = formmated_day
                                    i['start_shift'] = day + ' from ' + start_date_arrival_time +' to ' + start_date_departure_time
                                }
                                if(i.job_end_date){
                                    var day = moment(i.job_end_date).format("dddd DD/MM")
                                    var formmated_day = moment(i.job_end_date).format("MMMM DD, YYYY")
                                    i['job_end_date'] = formmated_day
                                    i['end_shift'] = day + ' from ' + end_date_arrival_time +' to ' + end_date_departure_time
                                }
                                if(i.close_date){
                                   var formmated_day = moment(i.close_date).format("MMMM DD, YYYY")
                                    i['close_date'] = formmated_day
                                }
                                

                            }

                                for (i of result) {
                                    var day = moment(result.date_applied).format("MMMM DD, YYYY")
                                    i['date_applied'] = day
                                    console.log('day',day)
                                    if (i.qualification){
                                        var k = '';
                                        var j;
                                        var r = '';
                                        console.log('qualification',JSON.parse(i.qualification));
                                         
                                        i['qualification'] =  Object.values(JSON.parse(i.qualification)).join(",");
                                        
                                        
                                    }

                                }
                                console.log('check status',result)
                                 this.setState({
                                job_detail : result
                            })

                             }

                        })
                        fetch((url + "/jobs/qualification/"), {
                            method: 'GET'
                            })
                          .then(res => res.json())
                          .then(
                            (result) => {
                            
                              this.setState({qualification: result})
                              console.log('qualification',result)
                            },
                            (error) => {
                              console.log('error',error)
                            })


         }
         return_string_data = (ids) => {
             console.log(ids)
             if(!ids){
                 return;
             }
            var result = []
              for(var each of this.state.qualification){
                  for(var id of ids){
                        if(each.id == id){
                            // console.log(id,each.id);
                            if(!result.includes(each.type)){
                                result.push(each.type)
                            }
                        }
                  }
              }
              return result.join(",")
          }
    
		 handelFormat = () => {
		    console.log('yes i am in')
		    if (this.state.card){
		        this.setState({
		            card: false,
		            list_active : 'active',
		            card_active : '',
		        })
		    }else{
		        this.setState({
		            card: true,
		            card_active : 'active',
		            list_active : '',
		        })

		    }
		 }
	handelcompression = (id) => {
        console.log('id',id)
            if (this.state.expand_id === id){
                if (this.state.expand === 'block'){
                    this.setState({expand : 'none'})
                    this.setState({expand_id : id})
                   }else{
                        this.setState({expand : 'block'})
                   }
            }else{
                  this.setState({expand : 'block'})
                  this.setState({expand_id : id})
            }
      }
tConvert (time) {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);// Remove full string match value
    console.log('helllio',time)
    time.splice(-1,1)
  }
  return time.join (''); // return adjusted time or original string
}
    render() {
        return <AcceptedJobView
            job_detail={this.state.job_detail}
            handledelete = {this.handledelete}
            card={this.state.card}
            handelFormat={this.handelFormat}
            card_active={this.state.card_active}
            return_string_data={this.return_string_data}
            list_active={this.state.list_active}
            handelcompression={this.handelcompression}
            expand={this.state.expand}
            expand_id={this.state.expand_id}
            length={this.state.length}
        />
    }
}

export default AcceptedJobComponent;